import { render, staticRenderFns } from "./PhoneFooter.vue?vue&type=template&id=1b3d3f2a"
import script from "./PhoneFooter.vue?vue&type=script&lang=js"
export * from "./PhoneFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports